import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SpinWheelEntity } from '../../domain/entities/SpinWheelEntity'
import type { SpinWheelAdminDto } from '@/backend/market'

export class SpinWheelModel extends SpinWheelEntity {
  constructor(dataDto: SpinWheelAdminDto) {
    super()
    mapEntityProperties<SpinWheelEntity>(this, dataDto)
  }
}
